var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallFlowsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-call_flows_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call_flows_Normal",
    "data-name": "call flows_Normal",
    clipPath: "url(#clip-call_flows_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call_flows",
    "data-name": "call flows",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2208",
    "data-name": "Group 2208",
    transform: "translate(0 8.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4820",
    "data-name": "Path 4820",
    d: "M24.26,32.348A1.425,1.425,0,0,1,23.8,32.3c-.223-.051-.446-.069-.652-.1-.257-.034-.5-.069-.72-.12a22.01,22.01,0,0,1-8.147-4.58,21.521,21.521,0,0,1-5.9-7.255c-.5-1.132-1.081-2.779-.48-3.928a15.111,15.111,0,0,1,2.916-3,1.273,1.273,0,0,1,.84-.309,1.244,1.244,0,0,1,.926.394l3.293,3.362a1.294,1.294,0,0,1,0,1.818c-1.235,1.252-1.492,1.921-1.509,2.093a17.439,17.439,0,0,0,3.087,3.242,20.921,20.921,0,0,0,2.864,2.144.606.606,0,0,0,.292.069c.549,0,1.338-.669,2.093-1.75a1.291,1.291,0,0,1,1.818-.326l3.808,2.727a1.312,1.312,0,0,1,.309,1.818L27.656,30c-.189.274-1.629,2.35-3.43,2.35Z",
    transform: "translate(-6.954 -12.314)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4821",
    "data-name": "Path 4821",
    d: "M11.956,13.972a.654.654,0,0,1,.446.189L15.7,17.523a.6.6,0,0,1,0,.858c-.652.669-1.8,1.972-1.681,2.693.12.755,2.624,3.053,3.328,3.653a21.434,21.434,0,0,0,2.984,2.23,1.37,1.37,0,0,0,.617.154c1.081,0,2.144-1.3,2.659-2.058a.6.6,0,0,1,.5-.257.57.57,0,0,1,.36.12l3.808,2.727a.607.607,0,0,1,.137.858l-.995,1.406s-1.355,2.041-2.864,2.041a1.056,1.056,0,0,1-.326-.034c-.5-.1-.978-.137-1.338-.223C18.011,30.49,11.3,24.847,9.3,20.25c-.377-.875-.978-2.436-.5-3.31a15.7,15.7,0,0,1,2.761-2.8.6.6,0,0,1,.394-.154m0-1.389h0a1.96,1.96,0,0,0-1.286.48c-2.5,2.127-2.95,2.933-3.087,3.207-.755,1.406-.1,3.259.446,4.528,2.178,4.991,9.245,10.926,14.528,12.229a6.331,6.331,0,0,0,.789.137c.206.034.412.051.6.1a3.79,3.79,0,0,0,.6.069,4.317,4.317,0,0,0,2.95-1.406,8.692,8.692,0,0,0,1.046-1.235l.978-1.389a2.01,2.01,0,0,0-.463-2.761l-3.808-2.727a2.013,2.013,0,0,0-1.166-.377,1.978,1.978,0,0,0-1.629.858,3.672,3.672,0,0,1-1.509,1.458,19.758,19.758,0,0,1-2.727-2.058,23.353,23.353,0,0,1-2.779-2.779,8.107,8.107,0,0,1,1.235-1.544,2.009,2.009,0,0,0,0-2.8L13.38,13.235a2.028,2.028,0,0,0-1.424-.6h0Z",
    transform: "translate(-7.241 -12.6)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2210",
    "data-name": "Group 2210",
    transform: "translate(10.961 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4822",
    "data-name": "Path 4822",
    d: "M22.743,26.342h-.034a9.491,9.491,0,0,1-9.039-9.5A9.643,9.643,0,0,1,23.189,7.32a9.52,9.52,0,0,1,5.4,17.358.69.69,0,0,1-.789-1.132,8.134,8.134,0,1,0-12.744-6.706,8.022,8.022,0,0,0,7.736,8.113.689.689,0,0,1,.652.72.681.681,0,0,1-.686.652Z",
    transform: "translate(-13.67 -7.32)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    "data-name": "Group 2209",
    transform: "translate(11.021 17.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4823",
    "data-name": "Path 4823",
    d: "M20.75,17.81s-.172.051-.24.069",
    transform: "translate(-19.799 -17.115)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4824",
    "data-name": "Path 4824",
    d: "M20.789,18.855a.7.7,0,0,1-.669-.515.671.671,0,0,1,.5-.84,1.109,1.109,0,0,0,.223-.069.7.7,0,1,1,.377,1.338c-.086.017-.172.051-.274.069-.051,0-.12.017-.172.017Z",
    transform: "translate(-20.095 -17.405)",
    fill: "#6f8b8f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2213",
    "data-name": "Group 2213",
    transform: "translate(15.539 4.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2211",
    "data-name": "Group 2211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4825",
    "data-name": "Path 4825",
    d: "M17.466,15.439a.649.649,0,0,1-.48-.206.683.683,0,0,1,0-.978L20.845,10.4a.691.691,0,0,1,.978.978l-3.859,3.859a.677.677,0,0,1-.48.206Z",
    transform: "translate(-16.008 -10.19)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4826",
    "data-name": "Path 4826",
    d: "M20.206,15.6h-3.19a.688.688,0,0,1-.686-.686v-3.19a.686.686,0,1,1,1.372,0v2.487h2.487a.686.686,0,0,1,0,1.372Z",
    transform: "translate(-16.33 -9.582)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2212",
    "data-name": "Group 2212",
    transform: "translate(3.911 3.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4827",
    "data-name": "Path 4827",
    d: "M19.3,17.719a.649.649,0,0,1-.48-.206.683.683,0,0,1,0-.978l3.859-3.859a.691.691,0,0,1,.978.978l-3.859,3.859a.677.677,0,0,1-.48.206Z",
    transform: "translate(-18.61 -11.732)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4828",
    "data-name": "Path 4828",
    d: "M23.309,16.585a.688.688,0,0,1-.686-.686V13.412H20.136a.686.686,0,1,1,0-1.372h3.19a.688.688,0,0,1,.686.686v3.19a.688.688,0,0,1-.686.686Z",
    transform: "translate(-18.009 -12.04)",
    fill: "#6f8b8f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFlowsNormal);
export default __webpack_public_path__ + "static/media/Call_Flows_Normal.6864e29a0a296beb51feae5c814d800a.svg";
export { ForwardRef as ReactComponent };